import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { sampleEmployeeData, sampleTimelogData } from "core/json/sample_data";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";

import { all_routes } from "Router/all_routes";
import * as Yup from "yup";
import { Table, DatePicker, Select } from "antd";
import { toast } from "core/Operations/toast";
import { useImportEmployeesMutation } from "AppQuries/employee/import-employee";
import { importTimelogValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import {
  useFormattedEmployees,
  useFormattedExcluedEmployeesOptions,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import dayjs from "dayjs";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import AlertMessage from "Components/UI/AlertMessage";

import { useUpdateTimeLogBulkMutation } from "AppQuries/attendance/time-log-bulk";

const { RangePicker } = DatePicker;
import { format, parseISO, parse, isValid, set } from "date-fns";
import moment from "moment";
import { useGenerateKetFormQuery } from "AppQuries/employee/ket-information";

const excelEpoch = new Date(Date.UTC(1899, 11, 30));

const parseExcelDateToISO = (value) => {
  if (typeof value === "number") {
    const date = new Date(excelEpoch.getTime() + value * 86400000);
    return isValid(date) ? format(date, "yyyy-MM-dd") : "";
  }

  if (typeof value === "string") {
    let date = parse(value, "dd-MM-yyyy", new Date());
    if (!isValid(date)) {
      date = parseISO(value);
    }
    return isValid(date) ? format(date, "yyyy-MM-dd") : "";
  }

  if (value instanceof Date) {
    return isValid(value) ? format(value, "yyyy-MM-dd") : "";
  }

  return "";
};
const KETInformation = () => {
  const userData = useSelector(loggedInUser);
  const companyCode = userData?.companyCode;
  const [isMount, setIsMount] = useState(false);
  const navigate = useNavigate();
  const validationSchema = Yup.array().of(importTimelogValidationSchema);
  const employeeOptions = useFormattedExcluedEmployeesOptions({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    departmentCode: userData?.departmentCode,
  });
  const [filterData, setFilterData] = useState({
    companyCode: userData?.companyCode,
    employeeCode: 0,
  });

  const {
    data: ketData,
    isLoading,
    refetch: ketRefetch,
    isError,
    error,
    isSuccess,
  } = useGenerateKetFormQuery(filterData);

  const updateFilterData = (key, value) => {
    setFilterData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleGenerateKetForm = () => {
    ketRefetch();
  };
  useEffect(() => {
    if (isSuccess && isMount) {
      if (ketData?.statusMessage === "Success") {
        // toast.success("KET form download started");
        const ketFormUrl = ketData?.reportURL;
        window.open(ketFormUrl, "_blank");
      }
      setIsMount(false); // reset after handling
    } else if (isError && isMount) {
      toast.error(error?.message || "Error generating KET form");
      setIsMount(false);
    }
  }, [ketData, isSuccess, isError, error, isMount]);

  useEffect(() => {
    if (ketData?.statusMessage === "Success") {
      setIsMount(true);
    }
  }, [ketData]);

  // useEffect(() => {
  //   if (isSuccess && !isMount) {
  //     console.log("ketData?.statusMessage", ketData);
  //     if (ketData?.statusMessage === "Success") {
  //       ketData.statusMessage === "";
  //       const ketFormUrl = ketData?.reportURL;
  //       window.open(ketFormUrl, "_blank");
  //       // const blob = new Blob([ketData?.reportData], { type: "application/pdf" });
  //       // saveAs(blob, `KET Form_${getCurrentFormattedDate()}.pdf`);

  //       // (async () => {
  //       //   try {
  //       //     const ketFormUrl = ketData?.reportURL;
  //       //     if (!ketFormUrl) throw new Error("No KET form URL available");

  //       //     const response = await fetch(ketFormUrl, { credentials: "include" });
  //       //     console.log("KET Form Response:", response);
  //       //     if (!response.ok) throw new Error("Failed to download KET form");

  //       //     const blob = await response.blob();

  //       //     // try to get filename from content-disposition header
  //       //     let filename = `KET_Form_${getCurrentFormattedDate()}.pdf`;
  //       //     const contentDisposition = response.headers.get("content-disposition");
  //       //     if (contentDisposition) {
  //       //       const fnMatch =
  //       //         contentDisposition.match(/filename\*=UTF-8''([^;]+)/) ||
  //       //         contentDisposition.match(/filename="?([^"]+)"?/);
  //       //       if (fnMatch && fnMatch[1]) {
  //       //         try {
  //       //           filename = decodeURIComponent(fnMatch[1]);
  //       //         } catch {
  //       //           filename = fnMatch[1];
  //       //         }
  //       //       }
  //       //     } else {
  //       //       // fallback to extension from content-type
  //       //       const contentType = response.headers.get("content-type") || "";
  //       //       const ext = contentType.split("/")[1]?.split(";")[0] || "pdf";
  //       //       filename = `KET_Form_${getCurrentFormattedDate()}.${ext}`;
  //       //     }

  //       //     saveAs(blob, filename);
  //       //     toast.success("KET form download started");
  //       //   } catch (err) {
  //       //     toast.error(err?.message || "Error downloading KET form");
  //       //   }
  //       // })();

  //     }
  //   } else if (isError) {
  //     toast.error(error?.message || "Error generating KET form");
  //   }
  //   setIsMount(true);
  // }, [ketData]);
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>KET Information</h4>
              <h6>Employees KET Information</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.attendance}${all_routes.time_log}`}
                className="btn btn-secondary"
              >
                
                Back
              </Link>
            </OverlayTrigger>
          </div> */}
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row form-row">
              <div className="col-md-3">
                <div className="form-floating">
                  <Select
                    placeholder="Select Employees"
                    className={`form-control`}
                    options={employeeOptions}
                    onChange={(selectedOptions) => {
                      console.log(selectedOptions);
                      updateFilterData("employeeCode", selectedOptions);
                    }}
                    showSearch
                    allowClear
                    updateFilterData={() => {
                      updateFilterData("employeeCode", 0);
                    }}
                    style={{ width: "100%", height: "auto" }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Employee</label>
                </div>
              </div>

              {filterData?.employeeCode ? (
                <>
                  <div className="col-lg-1 d-flex align-items-center">
                    <div className="d-grid align-items-center  mb-3">
                      <button
                        onClick={handleGenerateKetForm}
                        // onClick={() => generateExcel({ optionData })}
                        className="btn btn-submit"
                        type="button"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {filterData?.employeeCode && (
                    <div className="col-lg-1 d-flex align-items-center justify-content-end">
                      <div className="d-grid align-items-center  mb-3">
                        <Link
                          to={`${all_routes.fill_ket_information}/${filterData?.employeeCode}`}
                          // onClick={() => generateExcel({ optionData })}
                          className="btn btn-submit"
                          // type="button"
                        >
                          Generate
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
            {filterData?.employeeCode ? (
              ""
            ) : (
              <div className="row">
                <hr />
                <div className="col-md-12">
                  <AlertMessage
                    message="Please select employee"
                    type="danger"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KETInformation;
